import { createFeature } from '@ngrx/store';

import { sentInvoicesReducer } from './sent-invoices.reducer';

export const sentInvoicesFeature = createFeature({
  name: 'sentInvoices',
  reducer: sentInvoicesReducer,
});
